export const USER_SIGNUP = "userSignup/Success";
export const USER_SIGNUP_ERROR = "userSignup/Error";
export const USER_LOADING = "userLoading/process"
export const ISACTIVE = "isActive";
